/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CurrencyCustomFieldCreate } from '../models/CurrencyCustomFieldCreate';
import type { CurrencyCustomFieldOut } from '../models/CurrencyCustomFieldOut';
import type { CustomFieldPatch } from '../models/CustomFieldPatch';
import type { CustomFieldValueCreate } from '../models/CustomFieldValueCreate';
import type { CustomFieldValueOut } from '../models/CustomFieldValueOut';
import type { DateTimeCustomFieldCreate } from '../models/DateTimeCustomFieldCreate';
import type { DateTimeCustomFieldOut } from '../models/DateTimeCustomFieldOut';
import type { NoConfigCustomFieldCreate } from '../models/NoConfigCustomFieldCreate';
import type { NoConfigCustomFieldOut } from '../models/NoConfigCustomFieldOut';
import type { PasswordCustomFieldCreate } from '../models/PasswordCustomFieldCreate';
import type { PasswordCustomFieldOut } from '../models/PasswordCustomFieldOut';
import type { ReorderCustomFields } from '../models/ReorderCustomFields';
import type { ReorderCustomFieldValues } from '../models/ReorderCustomFieldValues';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CustomFieldsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List Custom Fields
     * List all custom fields (with values) for an object.
     * @returns any Successful Response
     * @throws ApiError
     */
    public listCustomFieldsApiV1CustomFieldsObjectObjectIdGet({
        objectId,
    }: {
        objectId: number,
    }): CancelablePromise<Array<(NoConfigCustomFieldOut | DateTimeCustomFieldOut | CurrencyCustomFieldOut | PasswordCustomFieldOut)>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/custom-fields/object/{object_id}',
            path: {
                'object_id': objectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reorder Custom Fields
     * Reorder custom fields on an object.
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderCustomFieldsApiV1CustomFieldsOrderObjectIdPut({
        objectId,
        requestBody,
    }: {
        objectId: number,
        requestBody: ReorderCustomFields,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/custom-fields/order/{object_id}',
            path: {
                'object_id': objectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Custom Field
     * Create a new custom field on an object, optionally with an initial value.
     * @returns any Successful Response
     * @throws ApiError
     */
    public createCustomFieldApiV1CustomFieldsPost({
        requestBody,
    }: {
        requestBody: (NoConfigCustomFieldCreate | DateTimeCustomFieldCreate | CurrencyCustomFieldCreate | PasswordCustomFieldCreate),
    }): CancelablePromise<(NoConfigCustomFieldOut | DateTimeCustomFieldOut | CurrencyCustomFieldOut | PasswordCustomFieldOut)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/custom-fields/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Custom Field
     * Update a custom field's definition (name, type, type_config, is_multi).
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateCustomFieldApiV1CustomFieldsFieldIdPatch({
        fieldId,
        requestBody,
    }: {
        fieldId: string,
        requestBody: CustomFieldPatch,
    }): CancelablePromise<(NoConfigCustomFieldOut | DateTimeCustomFieldOut | CurrencyCustomFieldOut | PasswordCustomFieldOut)> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/custom-fields/{field_id}',
            path: {
                'field_id': fieldId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Custom Field
     * Delete a custom field and all its values.
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteCustomFieldApiV1CustomFieldsFieldIdDelete({
        fieldId,
    }: {
        fieldId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/custom-fields/{field_id}',
            path: {
                'field_id': fieldId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reorder Custom Field Values
     * Reorder values of a multi-value custom field.
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderCustomFieldValuesApiV1CustomFieldsFieldIdValuesOrderPut({
        fieldId,
        requestBody,
    }: {
        fieldId: string,
        requestBody: ReorderCustomFieldValues,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/custom-fields/{field_id}/values/order',
            path: {
                'field_id': fieldId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Custom Field Value
     * Add a value to a (multi-value) custom field.
     * @returns CustomFieldValueOut Successful Response
     * @throws ApiError
     */
    public addCustomFieldValueApiV1CustomFieldsFieldIdValuesPost({
        fieldId,
        requestBody,
    }: {
        fieldId: string,
        requestBody: CustomFieldValueCreate,
    }): CancelablePromise<CustomFieldValueOut> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/custom-fields/{field_id}/values',
            path: {
                'field_id': fieldId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Custom Field Value
     * Update the value of a specific custom field value row.
     * @returns CustomFieldValueOut Successful Response
     * @throws ApiError
     */
    public updateCustomFieldValueApiV1CustomFieldsFieldIdValuesValueIdPatch({
        fieldId,
        valueId,
        requestBody,
    }: {
        fieldId: string,
        valueId: string,
        requestBody: CustomFieldValueCreate,
    }): CancelablePromise<CustomFieldValueOut> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/custom-fields/{field_id}/values/{value_id}',
            path: {
                'field_id': fieldId,
                'value_id': valueId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Custom Field Value
     * Remove a specific value row from a multi-value custom field.
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteCustomFieldValueApiV1CustomFieldsFieldIdValuesValueIdDelete({
        fieldId,
        valueId,
    }: {
        fieldId: string,
        valueId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/custom-fields/{field_id}/values/{value_id}',
            path: {
                'field_id': fieldId,
                'value_id': valueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
